import React, { FC } from "react"

export interface UIconProps {
  color?: string;
}

const UIcon: FC<UIconProps> = ({ color }) => {
  return (
    <svg
      version="1.1"
      id="svg2"
      width="100%"
      height="100%"
      viewBox="0 0 82.649353 82.742553"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inherit' }}
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath1340">
          <path
            d="m -519.5584,306.6078 h 1920 v -7442.871 h -1920 z"
            style={{ strokeWidth: 0.999998 }}
          />
        </clipPath>
      </defs>
      <g transform="matrix(1.3333333,0,0,-1.3333333,-621.59253,9538.88)">
        <g
          transform="translate(519.5584,7136.2632)"
          clipPath="url(#clipPath1340)"
        >
          <path
            d="m 0,0 v 5.919 c 0,1.509 -1.235,2.746 -2.745,2.746 h -5.239 c -1.51,0 -2.745,-1.237 -2.745,-2.746 V 0 c 0,-1.509 1.235,-2.745 2.745,-2.745 h 5.239 C -1.235,-2.745 0,-1.509 0,0 m -33.6,0 v 5.919 c 0,1.509 -1.235,2.746 -2.745,2.746 h -5.239 c -1.51,0 -2.745,-1.237 -2.745,-2.746 V 0 c 0,-1.509 1.235,-2.745 2.745,-2.745 h 5.239 c 1.51,0 2.745,1.236 2.745,2.745 m 11.469,-36.128 v 0.006 h 0.34 c 6.27,0 12.539,-0.002 18.809,0 1.395,0 2.997,1.009 2.988,3.008 -0.04,8.863 -0.017,17.725 -0.017,26.589 0,0.524 -0.002,0.526 -0.525,0.526 -3.172,10e-4 -6.345,10e-4 -9.517,0 -0.613,0 -0.614,-0.001 -0.614,-0.63 0,-6.761 0,-13.52 0,-20.281 0,-0.608 -10e-4,-0.609 -0.608,-0.609 -3.311,-0.001 -6.622,-0.001 -9.933,-0.001 -3.966,0 -7.931,0 -11.897,0.001 -0.492,10e-4 -0.514,0.026 -0.52,0.509 -10e-4,0.113 0,0.226 0,0.34 0,6.697 0,13.395 0,20.092 0,0.578 -10e-4,0.579 -0.588,0.579 -3.135,10e-4 -6.269,10e-4 -9.404,10e-4 -0.645,0 -0.646,-10e-4 -0.646,-0.627 v -26.098 c 0,-0.126 -0.003,-0.253 0.003,-0.379 0.045,-0.92 0.243,-1.754 1.052,-2.354 0.709,-0.524 1.493,-0.676 2.344,-0.675 6.244,0.005 12.489,0.003 18.733,0.003 m -31.229,23 c 0,5.349 -0.003,10.701 10e-4,16.051 0.003,3.54 1.181,6.671 3.406,9.392 2.513,3.073 5.77,4.884 9.7,5.474 0.611,0.091 1.226,0.108 1.844,0.108 10.689,-0.002 21.377,0.002 32.066,-0.005 C -2.748,17.89 0.415,16.666 3.16,14.377 5.994,12.016 7.732,8.994 8.409,5.366 8.543,4.649 8.62,3.925 8.62,3.19 8.615,-7.687 8.638,-18.565 8.604,-29.443 c -0.012,-3.506 -1.29,-6.597 -3.532,-9.269 -2.563,-3.055 -5.863,-4.809 -9.812,-5.339 -0.523,-0.069 -1.05,-0.105 -1.581,-0.105 -10.701,0.004 -21.403,-0.019 -32.104,0.015 -3.663,0.011 -6.896,1.292 -9.671,3.686 -2.72,2.348 -4.398,5.304 -5.058,8.834 -0.137,0.73 -0.211,1.467 -0.21,2.213 0.007,5.427 0.004,10.853 0.004,16.28"
            style={{ 'fill': color || '#ffffff', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
          />
        </g>
      </g>
    </svg>
  )
}

export default UIcon;
